/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import api from 'services/api';
import { IScholarsRequestData, IOverrideData, ICreateAnetapack } from 'types';
import { Dispatch } from 'redux';
import Logger from 'components/common/helpers/devConsoleLog';
import { createBlob } from 'utils/file';
import { setActiveScholar } from './users';
import {
  GET_SCHOLAR_DATA,
  GET_UNITS,
  DELETE_UNIT,
  SET_MERGE_ERROR,
  RESET_SCHOLARS_DATA,
  CREATE_SCHOLAR_ERROR,
  GET_UNIT_STATS,
  CREATE_ANETAPACK_ERROR,
} from './actionTypes';
import { showSpinner, hideSpinner } from './spinner';

const uploadAvatar = async (avatar: File): Promise<string> => {
  const type = avatar.name.split('.')[avatar.name.split.length - 1];
  const { data } = await api.post('/units/avatars', {
    type,
  });

  await fetch(data.url, {
    method: 'PUT',
    headers: {
      'Content-Type': `image/${type}`,
      'x-ms-blob-type': 'BlockBlob',
    },
    body: (await createBlob(avatar)) as ArrayBuffer,
  });
  return data.fileLocation;
};

export const createScholar = (
  createScholarDto: IScholarsRequestData,
  avatarFile?: File,
  avatarUrl?: string
) => async (dispatch: any): Promise<void> => {
  dispatch(showSpinner());
  try {
    let url = avatarUrl;
    if (avatarFile) {
      url = await uploadAvatar(avatarFile);
    }

    const { data } = await api.post('/units', {
      ...createScholarDto,
      avatar: url,
    });
    dispatch({
      type: CREATE_SCHOLAR_ERROR,
      payload: '',
    });
    localStorage.setItem('activeScholarId', data.id);
    dispatch(setActiveScholar(data.id));
    dispatch({
      type: GET_SCHOLAR_DATA,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_SCHOLAR_ERROR,
      payload: error.response.data?.message[0],
    });
    Logger('createScholar error:', error);
  } finally {
    dispatch(hideSpinner());
  }
};

export const createAnetapack = (
  createAnetapackData: ICreateAnetapack,
  avatarFile?: File,
  avatarUrl?: string
) => async (dispatch: any): Promise<void> => {
  dispatch(showSpinner());
  try {
    let url = avatarUrl;
    if (avatarFile) {
      url = await uploadAvatar(avatarFile);
    }

    const { data } = await api.post('/units', {
      ...createAnetapackData,
      avatar: url,
    });
    localStorage.setItem('activeScholarId', data.id);
    dispatch(setActiveScholar(data.id));
    dispatch({
      type: GET_SCHOLAR_DATA,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_ANETAPACK_ERROR,
      payload: error.response.data?.message,
    });
    Logger('createScholar error:', error);
  } finally {
    dispatch(hideSpinner());
  }
};

export const editScholar = (
  id: number,
  createScholarData: Partial<IScholarsRequestData>,
  avatarFile?: File,
  avatarUrl?: string
) => async (dispatch: any): Promise<void> => {
  dispatch(showSpinner());
  try {
    let url = avatarUrl;
    if (avatarFile) {
      url = await uploadAvatar(avatarFile);
    }

    const { data } = await api.put(`/units/${id}`, {
      ...createScholarData,
      avatar: url || undefined,
    });

    dispatch({
      type: GET_SCHOLAR_DATA,
      payload: data,
    });
  } catch (error) {
    Logger('editScholar error:', error);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getScholar = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get(`/units/${id}`);
    dispatch({
      type: GET_SCHOLAR_DATA,
      payload: data,
    });
  } catch (error) {
    Logger('getScholar error:', error);
  }
};

export const getUnitStats = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get(`/units/${id}/stat`);
    dispatch({
      type: GET_UNIT_STATS,
      payload: data,
    });
  } catch (error) {
    Logger('getUnitStats error:', error);
  }
};
export const clearUnitsErrors = () => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: CREATE_SCHOLAR_ERROR,
    payload: '',
  });
};

export const getUnits = () => async (dispatch: Dispatch): Promise<void> => {
  try {
    const { data } = await api.get(`/units/`);
    dispatch({
      type: GET_UNITS,
      payload: data,
    });
  } catch (error) {
    Logger('getUnits error:', error);
  }
};

export const deleteUnit = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    await api.delete(`/units/${id}`);
    dispatch({
      type: DELETE_UNIT,
      payload: id,
    });
  } catch (error) {
    Logger('deleteUnit error:', error);
  }
};

export const unitOverride = (
  unitId: number,
  data: IOverrideData
) => async (): Promise<void> => {
  try {
    await api.put(`/units/${unitId}/override`, data);
  } catch (error) {
    Logger('unitOverride error:', error);
  }
};

export const unitMerge = (
  unitId: number,
  data: any,
  onSuccess?: () => void
) => async (dispatch: Dispatch): Promise<void> => {
  try {
    await api.put(`/units/${unitId}/merge`, data);
    dispatch({
      type: SET_MERGE_ERROR,
      payload: '',
    });
    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    dispatch({
      type: SET_MERGE_ERROR,
      payload: error.response.data?.message[0],
    });
    Logger('unitMerge error:', error);
  }
};

export const resetScholarsData = (): { type: string } => {
  return {
    type: RESET_SCHOLARS_DATA,
  };
};
